export default "__VITE_ASSET__DhsoXx9$__"